var render = function render(){var _vm=this,_c=_vm._self._c;return _c('receive-order-item',{key:_vm.tabIndex,attrs:{"type":_vm.tabIndex},on:{"tab":_vm.onTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }